import OktaView from './OktaView'
export { OktaView } 
